var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutlink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h128v128H0z",
    fill: "#2e368f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 24.5v7.9H32.5v63.1h63V64.1h8v37.8c0 1.8.2 1.6-1.6 1.6H25.5c-.8.1-1-.2-1-1V25.7c0-.9.2-1.3 1.2-1.2H64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9 67.1 61 58.2l22.3-22.3L72 24.7c0-.1.1-.2.1-.3h30.3c.8 0 1.1.2 1.1 1.1v29.8c0 .2 0 .4-.1.7L92.3 44.7 69.9 67.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlink);
export default __webpack_public_path__ + "static/media/outlink.43e648e067d2bf9d0c65dd9ce9538c00.svg";
export { ForwardRef as ReactComponent };